import React from 'react'
import Page from 'v5/client/clientNeeds/ClientNeedsPageRelay.bs'
import { withMainLayout } from '../../pagesComponents/MainApp'
import { requireAuthenticatedAgent } from '../../hoc/AuthenticatedComponent'

const ProtectedPage = requireAuthenticatedAgent(Page)

function ClientNeedsPage() {
  return <ProtectedPage />
}

ClientNeedsPage.getLayout = withMainLayout

export default ClientNeedsPage
